import {DistanceType, SpellDistance} from '../../generated/types';

/** Размер фигуры прилагательным: «15-футовый», «30-футовая» */
export function toSpellDistanceFigure(distance: SpellDistance, sex?: string) {
	switch (distance.type) {
		case DistanceType.Feet:
			return `${distance.amount}-${sex === 'female' ? 'футовая' : 'футовый'}`;
	}
}
